import React from 'react';
import { NestedPivotNavGroup } from 'src/app/slice';
import { TabbedNavigation, TabbedNavigationItem } from '@amzn/storm-ui';
import { getCommonPivotItemProps } from './util';
import { LaunchFlag } from 'src/commons/components/LaunchFlag/LaunchFlag';
import { usePivotNavBundle } from 'src/providers/PantherLocalizationProvider/PantherLocalizationProvider';

export const MobilePivot: React.VFC<{
  menuItemGroups: Array<NestedPivotNavGroup>;
  selectedItemId: string;
}> = ({ menuItemGroups, selectedItemId }) => {
  const pivotnavTranslation = usePivotNavBundle();
  return (
    <div
      id="J_AACChromePivotNav"
      data-ccx-e2e-id="aac-pivotitems"
      aria-label={pivotnavTranslation.getMessage('pivot-nav-mobile-label')}
    >
      <TabbedNavigation>
        {menuItemGroups.map((group) => {
          return group?.links?.map((link) => {
            const endTag = link.flag && (
              <LaunchFlag
                flag={{
                  ...link.flag,
                  isMobile: true,
                }}
              />
            );
            const renderEnd = endTag ? () => endTag : undefined;
            const itemProps = {
              ...getCommonPivotItemProps(link, selectedItemId),
              renderEnd,
            };
            return <TabbedNavigationItem key={link.id} {...itemProps} />;
          });
        })}
      </TabbedNavigation>
    </div>
  );
};
